import { Theme } from "@mui/material/styles";
import pxToRem from "assets/theme/functions/pxToRem";
import rgba from "assets/theme/functions/rgba";

interface Styles {
  [key: string]: any;
}

export const styles = (theme: Theme): Styles => ({
  headerContainer: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    // Natural height from content — parent flex layout allocates remaining space to body.
    height: "auto",
    position: "relative",
    background: (theme.palette.background as any).primary,
    padding: theme.spacing.spacing10,
  },
  headerContainer_SHORT: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    height: "auto",
    position: "relative",
    padding: theme.spacing.spacing10,
  },
  headerContainerBG: {},
  headerContainerLeumit: {
    alignItems: "stretch",
    background: theme.palette.white.main,
    padding: `0 0 ${theme.spacing.spacing2}`,
  },
  logoRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: theme.width.full,
    padding: `${theme.spacing.spacing2} 0 ${theme.spacing.spacing8}`,
  },
  logoRowLeumit: {
    padding: `${theme.spacing.spacing12} ${theme.spacing.spacing10} ${theme.spacing.spacing8}`,
    boxShadow: theme.boxShadows.header,
  },
  brandLogo: {
    alignSelf: "flex-start",
    height: 36,
    width: theme.width.width62_5,
  },
  brandLogoLeumit: {
    height: 34,
    width: "auto",
    maxWidth: 120,
    objectFit: "contain",
  },
  userSection: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing.spacing4,
  },
  userAvatar: {
    width: 36,
    height: 36,
    borderRadius: "50%",
    objectFit: "cover",
    flexShrink: 0,
  },
  userName: {
    fontSize: theme.typography.size.sm,
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.primary.main,
    whiteSpace: "nowrap",
  },
  languageRow: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    width: theme.width.full,
    padding: `${theme.spacing.spacing2} ${theme.spacing.spacing8} ${theme.spacing.spacing2}`,
    borderTop: `1px solid ${rgba(theme.palette.black.main, 0.06)}`,
  },
  stepContentLeumit: {
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    width: theme.width.full,
    padding: `0 ${theme.spacing.spacing10} 0`,
  },
  title: {
    fontSize: theme.typography.size.md,
    fontWeight: theme.typography.fontWeightMedium,
    whiteSpace: "pre-line",
    textAlign: "center",
  },
  titleLeumit: {
    textAlign: "start",
    color: theme.palette.primary.main,
    marginTop: 0,
    fontSize: pxToRem(23),
  },
  titleWithMargin: {
    marginTop: theme.spacing.spacing14,
  },
  noPaddingTop: {
    paddingTop: 0,
  },
  descriptionWithMargin: {
    marginTop: theme.spacing.spacing10,
  },
  descriptionLeumit: {
    textAlign: "start",
  },
  largeTitle: {
    fontSize: theme.typography.size.size13,
    fontWeight: theme.typography.fontWeightMedium,
    whiteSpace: "pre-line",
    textAlign: "center",
  },
  descriptionSection: {
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.size.xs,
    width: theme.width.full,
  },
  descriptionBoxText: {
    alignSelf: "flex-start",
  },
  descriptionBoxTextLeumit: {
    textAlign: "start",
    color: (theme.palette.text as any).main,
  },
  descriptionBoxContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: theme.spacing.spacing25,
    background: rgba(theme.palette.white.main, 0.5),
    borderRadius: theme.borders.borderRadius.lg,
    padding: `${theme.spacing.spacing8} ${theme.spacing.spacing10}`,
  },
  descriptionBoxContainerLeumit: {
    justifyContent: "flex-start",
    gap: theme.spacing.spacing4,
    height: "auto",
    minHeight: theme.spacing.spacing16,
    background: (theme.palette.background as any).softAlt,
    borderRadius: theme.borders.borderRadius.xl,
    padding: `${theme.spacing.spacing6} ${theme.spacing.spacing8}`,
    textAlign: "start",
  },
  descriptionBoxAlertIcon: {
    flexShrink: 0,
    width: 18,
    height: 18,
    "& path": {
      fill: theme.palette.extraColors?.alert,
    },
  },
  descriptionBoxAlertText: {
    color: theme.palette.extraColors?.alert,
    fontSize: theme.typography.size.sm,
    fontWeight: theme.typography.fontWeightRegular,
    lineHeight: "20px",
  },
  stepsBoxDefault: {
    marginBottom: theme.spacing.spacing10,
  },
  stepsBoxLeumit: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: theme.width.full,
    background: (theme.palette.background as any).soft,
    borderRadius: theme.borders.borderRadius.lg,
    padding: `${theme.spacing.spacing9} ${theme.spacing.spacing10}`,
    marginTop: theme.spacing.spacing4,
  },
  description: {
    whiteSpace: "pre-line",
  },
  loadingCircle: {
    width: theme.width.width8,
    height: 16,
    margin: `0 ${theme.spacing.spacing5}`,
    borderRadius: 100,
  },
  languageWrapper: {
    display: "flex",
    alignItems: "center",
  },
  hmoSection: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: 50,
    gap: theme.spacing.spacing5,
  },
  hmoLogo: {
    height: 50,
    width: 50,
    objectFit: "contain",
  },
  hmoName: {
    fontSize: theme.typography.size.md,
    fontWeight: theme.typography.fontWeightMedium,
    textAlign: "center",
    color: (theme.palette.text as any).main,
  },
  //remove after testing
  versionText: {
    position: "absolute",
    top: theme.spacing.spacing5,
    right: theme.spacing.spacing5,
    fontSize: theme.typography.size.xxs,
    fontWeight: theme.typography.fontWeightRegular,
    color: (theme.palette.text as any).main,
    zIndex: 1,
  },
});
